interface ISidebarDivider {
  divider: boolean;
}

export interface ISidebarAction {
  // required
  text: string;
  onclick: () => void;

  // optional
  disabled?: boolean;
  icon?: string;
  hideInMobile?: boolean;
  component?: {
    type: string;
    props: {
      [key: string]: any;
    };
  };
}

export const baseActions = (
  context: any,
  enableSidebarToggle: boolean,
) => {
  const all = [
    {
      divider: true,
    },
    {
      text: 'Menu',
      onclick: () => context.$store.dispatch('chrome/toggleMenu'),
    },
  ] as Array<ISidebarAction | ISidebarDivider | boolean>;

  enableSidebarToggle
    && all.push({
      icon: context.isOpen ? '⫸' : '⫷',
      text: 'Sidebar',
      onclick: () => context.$store.dispatch('chromeEditor/toggleSidebar', !context.isOpen),
    });

  context.guide.length
    && all.push({
      text: 'Guide',
      onclick: () => context.$store.dispatch('chromeEditor/startGuide'),
      disabled: context.$store.state.chromeEditor.guideIndex > -1,
      hideInMobile: true,
    });

  return all;
};

interface IIconDef {
  [name: string]: string;
}

export const getIcon = (text = ''): string => (({
  assets: '⟰',
  clone: 'ꝏ',
  costs: '⅀',
  delete: '╳',
  guide: '𐐅',
  history: '๏๏',
  info: '𝔦',
  logout: 'ᚏ',
  menu: '三',
  print: 'ᚖ',
  product: '㊉',
  products: '⨌',
  save: '෴',
  vendors: 'ჶ',
  washing: '⌇',
} as IIconDef)[text.toLowerCase()]);

export default {
  baseActions,
};
